module.exports = __webpack_public_path__ + "static/media/amarant-desktop-screens.c036578f.png";